if (!customElements.get('video-hero')) {
  customElements.define(
    'video-hero',
    class VideoHero extends HTMLElement {
      connectedCallback() {
        this.video = this.querySelector('video');
        if (!this.video) return;

        // Respect reduced motion: leave the poster image in place, never load video.
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        this.desktopQuery = window.matchMedia('(min-width: 750px)');
        this.onBreakpointChange = this.applySource.bind(this);
        this.desktopQuery.addEventListener('change', this.onBreakpointChange);

        this.video.addEventListener('canplay', () => this.classList.add('video-hero--playing'));

        this.observer = new IntersectionObserver((entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              this.play();
            } else {
              this.video.pause();
            }
          });
        });
        this.observer.observe(this);

        this.applySource();
      }

      disconnectedCallback() {
        if (this.desktopQuery) this.desktopQuery.removeEventListener('change', this.onBreakpointChange);
        if (this.observer) this.observer.disconnect();
      }

      applySource() {
        const preferred = this.desktopQuery.matches ? this.dataset.srcDesktop : this.dataset.srcMobile;
        const src = preferred || this.dataset.srcDesktop || this.dataset.srcMobile;
        if (!src || this.video.getAttribute('src') === src) return;
        this.classList.remove('video-hero--playing');
        this.video.setAttribute('src', src);
        this.play();
      }

      play() {
        if (!this.video.getAttribute('src')) return;
        // Re-assert muted before play() — required for iOS autoplay.
        this.video.muted = true;
        const promise = this.video.play();
        if (promise) promise.catch(() => {});
      }
    }
  );
}
